/* eslint-disable no-use-before-define,jsx-a11y/iframe-has-title */
import React from 'react'
import { hideModal, Fields, fixURL } from '../../twd'

export default ({content, src, title, label, value, onAttest}) => {

    const [attested, setAttested] = React.useState(value || false)

    return <React.Fragment>
    <div
        date-name="attestations-modal"
        className="attestations-modal order-ticket-form modal-dialog modal-lg">
    <div className="modal-content">

        <div className="modal-header">
            <button
                date-name="attestations-modal-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h4 className="modal-title large-header text-center">
                {title}
            </h4>
        </div>

        <div className="modal-body" style={{width:'100%'}}>
            { content && <div style={{
                background:"#fff",
                border: '1px solid rgb(228, 228, 228)',
                padding: '10px',
                maxHeight: '600px',
                overflowY: 'auto',
            }}>{content}</div>}
            { !content && src && <iframe
                date-name="attestations-modal-frame"
                src={fixURL(src).toString()}
                marginHeight="0" marginWidth="0"
                frameBorder="0" scrolling="no"
                style={{height:'600px', width:'100%'}}
                /> }
        </div>

        <div className="modal-footer">
            <div className='text-center' style={{width:'100%'}}>
            <Fields.CheckboxLabel
                label={label}
                checkboxStyle={{}}
                style={{width:'100%'}}
                checked={attested}
                onChange={() => setAttested(!attested)}
                />
            <div aria-hidden={true} className="vertical-offset-sm"></div>
            <button
                disabled={!attested}
                className="btn btn-primary"
                type="button"
                onClick={() => {
                    hideModal()
                    onAttest(attested)
                }}
            >Submit</button>
            </div>
        </div>

    </div></div>

    </React.Fragment>
}


